import React  from 'react';
import {Text, View, StyleSheet, Image } from '@react-pdf/renderer';

const styles = StyleSheet.create({
    headerContainer: {
        marginTop: 36,
        fontSize: 9,     
    },    
    logo: {
        width: 74,
        height: 66,
        //marginLeft: 'auto',
        //marginRight: 'auto'
    }
  });


  const Sign = ({medical, patient}) => (

    <View style={styles.invoiceNoContainer}>
        <Image style={styles.logo} src={"https://my-market-mompos-online.s3.amazonaws.com/medisas-resource/"+ medical.id +".jpg"} />
        <Text>{medical.firstName} {medical.secondName} {medical.lastName} {medical.secondLastName}</Text>
        <Text >{medical.specialty}</Text>
        <Text>RM: {medical.rm}</Text>
  
    </View>
  );
  
  export default Sign